import { Accordion } from '@change/ds-core-ui/Accordion';
import { Text } from '@change/ds-core-ui/Text';
import { BlockIcon } from '@change/ds-icons/BlockIcon';
import { CheckIcon } from '@change/ds-icons/CheckIcon';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { Translate, TypedTranslate } from '@change-corgi/core-react/i18n';

import { ProgressiveImage } from './components/ProgressiveImage';
import { TIPS } from './constants';

export const MediaTips = () => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	return (
		<div className="bg-background-raised space-y-4 rounded-md p-6">
			<Text as="h2" variant="heading" size="small" className="m-0">
				<Translate value="corgi.start_a_petition.common.tips" />
			</Text>

			<div className="mb-6 flex items-center">
				<CheckIcon className="text-icon-success mr-2.5" size="small" />
				<Text as="h3" variant="heading" size="x-small">
					<Translate value="corgi.start_a_petition.media.tips.do_heading" />
				</Text>
			</div>
			{/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
			<ul role="list" className="space-y-2">
				{TIPS.do.map((tip, i) => (
					// eslint-disable-next-line react/no-array-index-key, jsx-a11y/no-redundant-roles
					<li role="listitem" key={`do-tip-${i}`}>
						{tip.image ? (
							<Accordion
								title={<TypedTranslate value={tip.text} />}
								variant="contained"
								className="bg-background-base border-none"
							>
								<ProgressiveImage
									src={getStaticAssetUrl(tip.image)}
									preview={tip.loadingImage}
									alt={tip.imageAlt}
									loading="lazy"
								/>
							</Accordion>
						) : (
							<Text className="bg-background-base flex rounded-lg px-6 py-4">
								<TypedTranslate value={tip.text} />
							</Text>
						)}
					</li>
				))}
			</ul>

			<div className="mb-6 flex items-center">
				<BlockIcon className="text-icon-error mr-2.5" size="small" />
				<Text as="h3" variant="heading" size="x-small">
					<Translate value="corgi.start_a_petition.media.tips.dont_heading" />
				</Text>
			</div>
			{/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
			<ul role="list" className="space-y-2">
				{TIPS.dont.map((tip, i) => (
					// eslint-disable-next-line jsx-a11y/no-redundant-roles, react/no-array-index-key
					<li role="listitem" key={`dont-tip-${i}`}>
						{tip.image ? (
							<Accordion
								title={<TypedTranslate value={tip.text} />}
								variant="contained"
								className="bg-background-base border-none"
							>
								<ProgressiveImage
									src={getStaticAssetUrl(tip.image)}
									preview={tip.loadingImage}
									alt={tip.imageAlt}
									loading="lazy"
								/>
							</Accordion>
						) : (
							<Text className="bg-background-base flex rounded-lg px-6 py-4">
								<TypedTranslate value={tip.text} />
							</Text>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};
